'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactCssModules = require('react-css-modules');

var _reactCssModules2 = _interopRequireDefault(_reactCssModules);

var _container = require('../../helpers/container');

var _container2 = _interopRequireDefault(_container);

var _config = require('config');

var _config2 = _interopRequireDefault(_config);

var _components = require('../../components');

var _AmazonVanguardThanks = require('./AmazonVanguardThanks.css');

var _AmazonVanguardThanks2 = _interopRequireDefault(_AmazonVanguardThanks);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AmazonVanguardThanks = (_dec = (0, _reactCssModules2.default)(_AmazonVanguardThanks2.default, { allowMultiple: true }), _dec(_class = function (_Component) {
  (0, _inherits3.default)(AmazonVanguardThanks, _Component);

  function AmazonVanguardThanks() {
    (0, _classCallCheck3.default)(this, AmazonVanguardThanks);
    return (0, _possibleConstructorReturn3.default)(this, (AmazonVanguardThanks.__proto__ || (0, _getPrototypeOf2.default)(AmazonVanguardThanks)).apply(this, arguments));
  }

  (0, _createClass3.default)(AmazonVanguardThanks, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      if (typeof window !== 'undefined') {
        window.scrollTo(0, 0);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var pageTitle = 'Thanks for your support';
      //
      return _react2.default.createElement(
        'div',
        { styleName: 'gray-bckgrnd' },
        _react2.default.createElement(
          'div',
          { styleName: 'page' },
          _container2.default.helmet(pageTitle, 'Thanks for your support for our petition calling on Vanguard to offer Amazon employees more sustainable 401(k) options.', _config2.default.domain + _config2.default.routes.amazonVanguardThanks),
          _react2.default.createElement(
            _components.ContainerDivs,
            null,
            _react2.default.createElement(
              'h1',
              { styleName: 'large-page-title' },
              'Thank you for your support!'
            ),
            _react2.default.createElement(_components.AmazonVanguardLetters, null),
            _react2.default.createElement(_components.AmazonStaffTakeActionShare, null)
          ),
          _react2.default.createElement(_components.PlanScorecardToActionCenter, null),
          _react2.default.createElement('br', null),
          _react2.default.createElement('br', null),
          _react2.default.createElement('br', null)
        )
      );
    }
  }]);
  return AmazonVanguardThanks;
}(_react.Component)) || _class);
exports.default = AmazonVanguardThanks;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/AmazonVanguardThanks/AmazonVanguardThanks.js
// module id = 1460
// module chunks = 0